import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/soyuz/client';

import './AlertWrapper.scss';

const AlertWrapper = props => {
  const { outOfDate } = props;
  const className = classNames('alert__wrapper', {
    'alert__wrapper--error': outOfDate
  });

  return (
    <div className="alert">
      <div className={className}>
        <div className="alert__content-wrapper">
          <div className="alert__city">{props.city}</div>
          <div className="alert__content">{props.content}</div>
        </div>
        <div className="alert__buttons">{props.renderButtons()}</div>
      </div>
      {outOfDate && (
        <div className="alert__error-message">
          {trans('alerts.alert.out_of_date')}
        </div>
      )}
    </div>
  );
};

AlertWrapper.propTypes = {
  city: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  renderButtons: PropTypes.func.isRequired,
  outOfDate: PropTypes.bool
};

AlertWrapper.defaultProps = {
  outOfDate: false
};

export default AlertWrapper;
